import { createSvgIcon } from '@mui/material';

const TotalInProcess = createSvgIcon(
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M20 7.50002L12 3.00002L4 7.50002M20 7.50002V16.5L12 21M20 7.50002L12 12M12 21L4 16.5V7.50002M12 21V12M4 7.50002L12 12M16 5.25002L12 7.50002L8 9.75002"
      stroke="black"
      strokeWidth="0.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16 16.5C16 16.9596 16.0905 17.4148 16.2664 17.8394C16.4423 18.264 16.7001 18.6499 17.0251 18.9749C17.3501 19.2999 17.736 19.5577 18.1606 19.7336C18.5852 19.9095 19.0404 20 19.5 20C19.9596 20 20.4148 19.9095 20.8394 19.7336C21.264 19.5577 21.6499 19.2999 21.9749 18.9749C22.2999 18.6499 22.5577 18.264 22.7336 17.8394C22.9095 17.4148 23 16.9596 23 16.5C23 15.5718 22.6313 14.6815 21.9749 14.0251C21.3185 13.3688 20.4283 13 19.5 13C18.5717 13 17.6815 13.3688 17.0251 14.0251C16.3687 14.6815 16 15.5718 16 16.5Z"
      fill="white"
    />
    <path d="M17.9444 16.5L19.5 18.0556Z" fill="white" />
    <path d="M19.5 14.9445V18.0556Z" fill="white" />
    <path d="M21.0556 16.5L19.5 18.0556Z" fill="white" />
    <path
      d="M17.9444 16.5L19.5 18.0556M19.5 18.0556V14.9445M19.5 18.0556L21.0556 16.5M16 16.5C16 16.9596 16.0905 17.4148 16.2664 17.8394C16.4423 18.264 16.7001 18.6499 17.0251 18.9749C17.3501 19.2999 17.736 19.5577 18.1606 19.7336C18.5852 19.9095 19.0404 20 19.5 20C19.9596 20 20.4148 19.9095 20.8394 19.7336C21.264 19.5577 21.6499 19.2999 21.9749 18.9749C22.2999 18.6499 22.5577 18.264 22.7336 17.8394C22.9095 17.4148 23 16.9596 23 16.5C23 15.5718 22.6313 14.6815 21.9749 14.0251C21.3185 13.3688 20.4283 13 19.5 13C18.5717 13 17.6815 13.3688 17.0251 14.0251C16.3687 14.6815 16 15.5718 16 16.5Z"
      stroke="#EC645E"
      strokeWidth="0.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>,
  'TotalInProcess',
);

export default TotalInProcess;
